import PropTypes from 'prop-types';
import React from 'react';
import { SECOND_CHECKOUT_STEPS } from '../../config/constants/steps';
import { BENEFITS } from '../../config/text/text';
import Step from './stepper/Step';
import Stepper from './stepper/Stepper';

const CheckoutStepper = ({ activeStep = '0', hasBenefits }) => {
  return (
    <>
      <Stepper width="100%">
        {SECOND_CHECKOUT_STEPS.map((step, index) => {
          return (
            <Step
              activeIcon={step.activeIcon}
              activeStep={activeStep}
              forwardStepIcon={step.forwardStepIcon}
              hide={step.title === BENEFITS && !hasBenefits}
              isActive={index + 1 == activeStep}
              isCompleted={index + 1 < activeStep}
              isDeal={step.isDeal}
              key={`step-${index + 1}`}
              size={step.size}
              stepIcon={step.stepIcon}
              title={step.title}
            />
          );
        })}
      </Stepper>
    </>
  );
};

CheckoutStepper.propTypes = {
  activeStep: PropTypes.string,
  hasBenefits: PropTypes.bool,
};

export default CheckoutStepper;
